import { AbstractPmsApiService } from "./abstract.service";
import { MabeetPaymentGatewayApiSettings } from "../models";

/**
 * @abstract
 * @extends {AbstractPmsApiService<MabeetPaymentGatewayApiSettings>}
 */
export class MabeetPaymentGatewayApiSettingsService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/mabeet-payment-gateway-api-settings';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {MabeetPaymentGatewayApiSettings}
     * @protected
     */
    newModel(attributes, ...params) {

        return new MabeetPaymentGatewayApiSettings(attributes);
    }

    /**
     * @returns {Promise.<MabeetPaymentGatewayApiSettings>}
     */
    get() {
        return this.http
            .get(this.url(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {MabeetPaymentGatewayApiSettings} MabeetPaymentGatewayApiSettings
     * @returns {Promise.<MabeetPaymentGatewayApiSettings>}
     */
    save(MabeetPaymentGatewayApiSettings) {
        return this.http
            .post(this.url(), MabeetPaymentGatewayApiSettings, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/mabeet-payment-gateway-api-settings.service.js